@if (formData.formGroup) {
  <section class="image-gallery">
    <div class="input-wrapper"
         (click)="uploadImage.click()">
      <section class="input-section">
        <input [type]="formData.type"
               class="input"
               #uploadImage
               [id]="formData.id"
               accept="image/png,image/jpeg,image/jpg"
               [multiple]="formData.multiple"
               hidden
               (change)="onFileChange($event)">

        <span class="material-symbols-rounded upload-icon">
          upload_file
        </span>

        <p class="upload-text">
          Bilder hochladen
        </p>
      </section>
    </div>

    @if (formData.formGroup.value?.images?.currentImages?.length) {
      @for (image of formData.formGroup.value.images.currentImages; track image; let i = $index) {
        <div class="current-images">
          <img [src]="bypassUrl(imagePath + image.url)"
               class="current-image"
               [class.pending-delete-image]="image.pendingDelete"
               alt="Current Image">

          @if (formData.canDelete && !image.pendingDelete) {
            <app-button-icon iconName="delete"
                             class="red remove-image"
                             (click)="removeImage(i)" />
          }
          @if (image.pendingDelete) {
            <app-button-icon iconName="cancel"
                             class="warning remove-image"
                             (click)="cancelDeleteImage(i)" />
          }
        </div>

      }
    }

    @if (newFilePreviews.length > 0) {
      @for (file of newFilePreviews; track file.file.name) {
        <div class="new-files">
          <img class="selected-file"
               src="{{ file.url }}"
               alt="New Image">

          <app-button-icon iconName="remove"
                           class="warning remove-image"
                           (click)="removeImageFromNew(file.url)" />
        </div>
      }
    }
  </section>
}